@if (service.instrument$ | async | isKnockedOut) {
  <div class="zero-surface tertiary-800 p-3 mb-4 b-r-8" data-zid="knocked-out-hint">
    <div class="zero-text p-base-bold dark-red mb-2">{{ 'instrument-detail.knocked-out-hint.headline' | transloco }}</div>
    <div class="zero-text p-small-reg dark-red">{{ 'instrument-detail.knocked-out-hint.text' | transloco }}</div>
  </div>
}
